import React from 'react'

const CheckmarkIcon = (props: React.SVGProps<SVGSVGElement>) => {
	return (
		<svg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16.4233 6.4207L7.50071 15.3433L3.57812 11.4207L4.75664 10.2422L7.50071 12.9863L15.2448 5.24219L16.4233 6.4207Z'
				fill='#008700'
			/>
			<g opacity='0.6'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M22.4233 6.4207L13.5007 15.3433L9.57812 11.4207L10.7566 10.2422L13.5007 12.9863L21.2448 5.24219L22.4233 6.4207Z'
					fill='#008700'
				/>
			</g>
		</svg>
	)
}

export default CheckmarkIcon
